import { createApplicationState } from '../applicationState';
import { renderApplication } from '../renderApplication';

import { createContext } from './createContext';

export async function runApp(): Promise<void> {
  const context = createContext();

  const store = createApplicationState(context);

  await renderApplication({ context, store });
}
